/* globals window */
import { React, PT, connect } from '@gasbuddy/react';
import { Button, Form, Loader, Dimmer, Container, Message, Image, Card } from 'semantic-ui-react';
import { Action } from '../../reducers/actions';
import { VerticalCenter } from '../../components/vertical-center';

function goHome(event) {
  event.preventDefault();
  window.location = '/';
}

class BaseSignupPage extends React.Component {
  state = {
    code: '',
    password: '',
  }

  onChangeFunctor(fieldName) {
    return (event) => {
      this.setState({ [fieldName]: event.target.value });
    };
  }

  submitSignupData = (event) => {
    event.preventDefault();

    const { match, api: { verify }, dispatch } = this.props;
    const { body: verifyData } = verify || {};
    const { password, code } = this.state;
    const isVerified = !!(verifyData && verifyData.valid);

    if (isVerified) {
      // Submit password
      if (password.length < 6) {
        this.setState({ complexityError: true });
        return;
      }
      dispatch({
        type: `${Action.Api.Base}otp`,
        meta: { apiAction: true },
        payload: {
          url: '/identity/signup/set',
          body: {
            code,
            token: match.params.token,
            password,
          },
        },
      });
    } else {
      dispatch({
        type: `${Action.Api.Base}verify`,
        meta: { apiAction: true },
        payload: {
          url: '/identity/signup/verify',
          body: {
            code,
            token: match.params.token,
          },
        },
      });
    }
  }

  render() {
    const { complexityError, code, password } = this.state;
    const { api: { verify, otp } } = this.props;
    const { loading, body: verifyData } = verify || {};
    const isVerified = !!(verifyData && verifyData.valid);

    if (otp && otp.body) {
      return (
        <VerticalCenter>
          <Container text>
            <Card style={{ margin: 'auto' }}>
              <Image height="200" width="200" centered src={otp.body.qr} />
              <Card.Header>
                One-Time Password Seed
              </Card.Header>
              <Card.Content>
                You must add this one time password secret to a two factor app
                now, you will not be able to retrieve this secret again.
              </Card.Content>
              <Card.Content extra>
                <Button fluid onClick={goHome}>Done</Button>
              </Card.Content>
            </Card>
          </Container>
        </VerticalCenter>
      );
    }

    return (
      <VerticalCenter>
        <Container text>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>

            <Form method="POST" error={complexityError}>
              <Message error hidden={!complexityError}>
                Your password is too short. This is an administrative site,
                use a password generator and a secure store.
              </Message>

              {!isVerified
                && (
                <Form.Field>
                  <Form.Input
                    label="Enter Your Signup Code"
                    placeholder="12345677890ABCDEF"
                    name="signupCode"
                    onChange={this.onChangeFunctor('code')}
                    value={code}
                  />
                </Form.Field>
                )
              }

              {isVerified
                && (
                <Form.Field>
                  <Form.Input
                    label="Choose a Password"
                    placeholder="**********"
                    name="password"
                    type="password"
                    onChange={this.onChangeFunctor('password')}
                    value={password}
                  />
                </Form.Field>
                )
              }

              <Button onClick={this.submitSignupData}>Submit</Button>
            </Form>
          </Dimmer.Dimmable>
        </Container>
      </VerticalCenter>
    );
  }
}

BaseSignupPage.propTypes = {
  match: PT.shape({ params: PT.shape({ token: PT.string }) }).isRequired,
  dispatch: PT.func.isRequired,
  api: PT.shape({
    verify: { loading: PT.bool },
    otp: { loading: PT.bool },
  }).isRequired,
};

export const SignupPage = connect(({ api }) => ({ api }))(BaseSignupPage);
